import { useState } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const IMG_BASE = '/images/volani/WhatsApp%20Image%202026-06-13%20at%20';

const allImages = [
  '12.36.29%20(1).jpeg',
  '12.36.29.jpeg',
  '12.36.30%20(1).jpeg',
  '12.36.30%20(2).jpeg',
  '12.36.30.jpeg',
  '12.36.31%20(1).jpeg',
  '12.36.31%20(2).jpeg',
  '12.36.31.jpeg',
  '12.36.32%20(1).jpeg',
  '12.36.32%20(2).jpeg',
  '12.36.32%20(3).jpeg',
  '12.36.32%20(4).jpeg',
  '12.36.32%20(5).jpeg',
  '12.36.32%20(6).jpeg',
  '12.36.32.jpeg',
  '12.36.33%20(1).jpeg',
  '12.36.33%20(2).jpeg',
  '12.36.33%20(3).jpeg',
  '12.36.33%20(4).jpeg',
  '12.36.33.jpeg',
  '12.36.34%20(1).jpeg',
  '12.36.34%20(2).jpeg',
  '12.36.34%20(3).jpeg',
  '12.36.34%20(4).jpeg',
  '12.36.34.jpeg',
  '12.36.35%20(1).jpeg',
  '12.36.35%20(2).jpeg',
  '12.36.35%20(3).jpeg',
  '12.36.35%20(4).jpeg',
  '12.36.35%20(5).jpeg',
  '12.36.35.jpeg',
  '12.36.36%20(1).jpeg',
  '12.36.36%20(2).jpeg',
  '12.36.36%20(3).jpeg',
  '12.36.36%20(4).jpeg',
  '12.36.36.jpeg',
  '12.36.37%20(1).jpeg',
  '12.36.37%20(2).jpeg',
  '12.36.37%20(3).jpeg',
  '12.36.37%20(4).jpeg',
  '12.36.37%20(5).jpeg',
  '12.36.37%20(6).jpeg',
  '12.36.37.jpeg',
  '12.36.38%20(1).jpeg',
  '12.36.38%20(2).jpeg',
  '12.36.38%20(3).jpeg',
  '12.36.38%20(4).jpeg',
  '12.36.38%20(5).jpeg',
  '12.36.38%20(6).jpeg',
  '12.36.38%20(7).jpeg',
  '12.36.38.jpeg',
  '12.36.39%20(1).jpeg',
  '12.36.39%20(2).jpeg',
  '12.36.39%20(3).jpeg',
  '12.36.39%20(4).jpeg',
  '12.36.39%20(5).jpeg',
  '12.36.39.jpeg',
  '12.36.40%20(1).jpeg',
  '12.36.40%20(2).jpeg',
  '12.36.40.jpeg',
  '12.36.41%20(1).jpeg',
  '12.36.41%20(2).jpeg',
  '12.36.41%20(3).jpeg',
  '12.36.41%20(4).jpeg',
  '12.36.41%20(5).jpeg',
  '12.36.42%20(1).jpeg',
  '12.36.42%20(2).jpeg',
  '12.36.42.jpeg',
  '12.36.43%20(1).jpeg',
  '12.36.43%20(2).jpeg',
  '12.36.43%20(3).jpeg',
  '12.36.43%20(4).jpeg',
  '12.36.43.jpeg',
  '12.36.44%20(1).jpeg',
  '12.36.44%20(2).jpeg',
  '12.36.44.jpeg',
  '12.36.45.jpeg',
  '12.36.46%20(1).jpeg',
  '12.36.46%20(2).jpeg',
  '12.36.46%20(3).jpeg',
  '12.36.46%20(4).jpeg',
  '12.36.46%20(5).jpeg',
  '12.36.46.jpeg',
  '12.36.47%20(1).jpeg',
  '12.36.47%20(2).jpeg',
  '12.36.47%20(3).jpeg',
  '12.36.47.jpeg',
  '12.36.48%20(1).jpeg',
  '12.36.48%20(2).jpeg',
  '12.36.48%20(3).jpeg',
  '12.36.48%20(4).jpeg',
  '12.36.48%20(5).jpeg',
  '12.36.48%20(6).jpeg',
  '12.36.48%20(7).jpeg',
  '12.36.48%20(8).jpeg',
  '12.36.48%20(9).jpeg',
  '12.36.48.jpeg',
  '12.36.49%20(1).jpeg',
  '12.36.49.jpeg',
].map(f => IMG_BASE + f);

const steps = [
  {
    num: '01',
    title: 'Ship Your Wheel',
    desc: 'Remove your steering wheel and ship it to us. We accept wheels from any make or model — OEM, aftermarket, race, street.',
    icon: 'ri-send-plane-line',
  },
  {
    num: '02',
    title: 'We Craft It',
    desc: 'Our craftsmen wrap, trim, and finish your wheel in dry carbon. Shape, spoke design, stitch position, finish — fully your call.',
    icon: 'ri-tools-line',
  },
  {
    num: '03',
    title: 'We Ship It Back',
    desc: 'Your wheel comes back transformed. Fully insured shipping. Usually 2–3 weeks from arrival to delivery.',
    icon: 'ri-truck-line',
  },
];

export default function SteeringWheelPage() {
  const navigate = useNavigate();
  const [lightbox, setLightbox] = useState<string | null>(null);
  const [lightboxIdx, setLightboxIdx] = useState(0);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const openLightbox = (src: string, idx: number) => {
    setLightbox(src);
    setLightboxIdx(idx);
  };

  const closeLightbox = () => setLightbox(null);

  const prevImage = () => {
    const idx = (lightboxIdx - 1 + allImages.length) % allImages.length;
    setLightboxIdx(idx);
    setLightbox(allImages[idx]);
  };

  const nextImage = () => {
    const idx = (lightboxIdx + 1) % allImages.length;
    setLightboxIdx(idx);
    setLightbox(allImages[idx]);
  };

  useEffect(() => {
    if (!lightbox) return;
    const handler = (e: KeyboardEvent) => {
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowLeft') prevImage();
      if (e.key === 'ArrowRight') nextImage();
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [lightbox, lightboxIdx]);

  return (
    <div className="bg-white min-h-screen">
      <Navbar />

      {/* ── HERO ──────────────────────────────────────────────────────── */}
      <section className="relative bg-black min-h-[85vh] flex items-end overflow-hidden">
        {/* Background image — first gallery shot */}
        <div className="absolute inset-0">
          <img
            src={`${IMG_BASE}12.36.40%20(2).jpeg`}
            alt="Custom carbon steering wheel"
            className="w-full h-full object-cover object-center opacity-40"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black via-black/60 to-black/30" />
        </div>

        <div className="relative z-10 max-w-[1400px] mx-auto px-4 sm:px-8 pb-16 md:pb-24 pt-40 md:pt-48 w-full">
          <div className="flex items-center gap-3 mb-4 md:mb-6">
            <div className="w-8 md:w-12 h-[2px] bg-white/30"></div>
            <span className="text-gray-400 text-xs uppercase tracking-[4px] font-bold">Budzevina Carbon</span>
          </div>
          <h1 className="text-white text-5xl sm:text-7xl md:text-[8rem] font-black tracking-tighter leading-none mb-4 md:mb-6">
            CUSTOM<br />
            <span className="text-gray-400">STEERING</span><br />
            WHEELS
          </h1>
          <p className="text-gray-300 text-lg md:text-2xl max-w-2xl mb-8 md:mb-12 font-light leading-relaxed">
            No stock. No catalogue. Send us your wheel — we turn it into something extraordinary.
          </p>
          <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-4">
            <div className="bg-white px-8 py-4 text-black font-black text-xl md:text-2xl tracking-tight whitespace-nowrap self-start">
              From <span className="text-black">€650</span>
            </div>
            <a
              href="https://wa.me/381642428074"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center gap-3 border-2 border-white text-white px-8 py-4 font-bold text-sm uppercase tracking-wider hover:bg-white hover:text-black transition-all cursor-pointer"
            >
              <i className="ri-whatsapp-line text-xl"></i>
              Start Your Build on WhatsApp
            </a>
          </div>
        </div>
      </section>

      {/* ── THE PITCH ──────────────────────────────────────────────────── */}
      <section className="bg-white py-16 md:py-28">
        <div className="max-w-[1400px] mx-auto px-4 sm:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-20 items-center">
            <div>
              <div className="flex items-center gap-3 mb-6 md:mb-8">
                <div className="w-8 md:w-12 h-[2px] bg-black"></div>
                <span className="text-gray-500 text-xs uppercase tracking-[3px] font-bold">THE CONCEPT</span>
              </div>
              <h2 className="text-black text-4xl md:text-6xl font-black tracking-tighter leading-[1.05] mb-6 md:mb-8">
                SEND US<br />YOUR WHEEL.<br />
                <span className="text-gray-400">WE DO THE REST.</span>
              </h2>
              <p className="text-gray-600 text-base md:text-lg leading-relaxed mb-5 md:mb-8">
                We carry zero stock. Every single wheel we produce is built specifically for the person who ordered it — the shape, the spoke pattern, the flat-bottom cut, the stitch colour, the finish. All of it is decided by you.
              </p>
              <p className="text-gray-600 text-base md:text-lg leading-relaxed mb-8 md:mb-10">
                This is a personal service. You ship us your steering wheel — whether it's the OEM unit from your daily driver or an aftermarket race wheel — and we return it fully transformed in dry carbon. No compromise, no standard options, no limits.
              </p>
              <div className="border-l-4 border-black pl-5 py-3">
                <p className="text-black text-xl md:text-2xl font-black leading-tight italic">
                  "You can send us your wheel and we can do whatever you want!"
                </p>
              </div>
            </div>

            {/* Right — stat blocks */}
            <div className="grid grid-cols-2 gap-4 md:gap-6">
              {[
                { val: '100%', label: 'Custom — no two alike' },
                { val: 'Any', label: 'Make or model accepted' },
                { val: '€650+', label: 'Starting price' },
                { val: '2–3w', label: 'Typical turnaround' },
              ].map((s, i) => (
                <div key={i} className="bg-gray-50 border-t-4 border-black p-6 md:p-8">
                  <div className="text-black text-4xl md:text-5xl font-black mb-2">{s.val}</div>
                  <div className="text-gray-500 text-xs uppercase tracking-wider font-semibold">{s.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ── HOW IT WORKS ──────────────────────────────────────────────── */}
      <section className="bg-black py-16 md:py-24">
        <div className="max-w-[1400px] mx-auto px-4 sm:px-8">
          <div className="text-center mb-12 md:mb-16">
            <div className="flex items-center justify-center gap-3 mb-4 md:mb-6">
              <div className="w-8 md:w-12 h-[2px] bg-white/20"></div>
              <span className="text-gray-500 text-xs uppercase tracking-[4px] font-bold">THE PROCESS</span>
              <div className="w-8 md:w-12 h-[2px] bg-white/20"></div>
            </div>
            <h2 className="text-white text-4xl md:text-6xl font-black tracking-tighter uppercase">How It Works</h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
            {steps.map((step, i) => (
              <div key={i} className="relative border border-white/10 p-8 md:p-10 group hover:border-white/30 transition-all">
                {/* Step number */}
                <div className="absolute top-0 left-0 bg-white text-black text-sm font-black px-3 py-1.5 tracking-wider">
                  {step.num}
                </div>
                <div className="w-14 h-14 flex items-center justify-center bg-white/5 mb-6 mt-4">
                  <i className={`${step.icon} text-white text-3xl`}></i>
                </div>
                <h3 className="text-white text-xl md:text-2xl font-black uppercase tracking-tight mb-3">{step.title}</h3>
                <p className="text-gray-400 text-sm md:text-base leading-relaxed">{step.desc}</p>
                {i < steps.length - 1 && (
                  <div className="hidden md:block absolute top-1/2 -right-4 -translate-y-1/2 z-10">
                    <i className="ri-arrow-right-line text-white/20 text-2xl"></i>
                  </div>
                )}
              </div>
            ))}
          </div>

          {/* Shipping note */}
          <p className="text-center text-gray-500 text-sm mt-8 md:mt-10">
            Not sure how to remove your wheel? We'll guide you through it. Just message us on WhatsApp.
          </p>
        </div>
      </section>

      {/* ── GALLERY ───────────────────────────────────────────────────── */}
      <section className="bg-gray-50 py-16 md:py-24">
        <div className="max-w-[1600px] mx-auto px-4 sm:px-8">
          <div className="mb-10 md:mb-14">
            <div className="flex items-center gap-3 mb-4 md:mb-6">
              <div className="w-8 md:w-12 h-[2px] bg-black"></div>
              <span className="text-gray-500 text-xs uppercase tracking-[3px] font-bold">OUR WORK</span>
            </div>
            <h2 className="text-black text-4xl md:text-6xl font-black tracking-tighter uppercase leading-[1.05]">
              Steering Wheel<br />
              <span className="text-gray-400">Gallery</span>
            </h2>
            <p className="text-gray-500 text-base md:text-lg mt-4 max-w-2xl">
              Every wheel below was sent to us by a customer. Every one is unique. Click any image to view full size.
            </p>
          </div>

          {/* Masonry-style grid — CSS columns */}
          <div
            className="columns-2 sm:columns-3 lg:columns-4 xl:columns-5 gap-3 md:gap-4"
            style={{ columnGap: '12px' }}
          >
            {allImages.map((src, idx) => (
              <div
                key={idx}
                className="break-inside-avoid mb-3 md:mb-4 group relative overflow-hidden cursor-pointer bg-gray-200"
                onClick={() => openLightbox(src, idx)}
              >
                <img
                  src={src}
                  alt={`Steering wheel build ${idx + 1}`}
                  loading="lazy"
                  className="w-full h-auto block group-hover:scale-105 transition-transform duration-500"
                />
                {/* Hover overlay */}
                <div className="absolute inset-0 bg-black/50 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                  <i className="ri-zoom-in-line text-white text-3xl"></i>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── PRICING + CTA ─────────────────────────────────────────────── */}
      <section className="bg-black py-16 md:py-24">
        <div className="max-w-[1400px] mx-auto px-4 sm:px-8 text-center">
          <div className="flex items-center justify-center gap-3 mb-6 md:mb-8">
            <div className="w-8 md:w-12 h-[2px] bg-white/20"></div>
            <span className="text-gray-500 text-xs uppercase tracking-[4px] font-bold">PRICING</span>
            <div className="w-8 md:w-12 h-[2px] bg-white/20"></div>
          </div>

          <div className="text-white text-6xl md:text-8xl font-black tracking-tighter mb-2">From €650</div>
          <p className="text-gray-400 text-base md:text-xl mb-10 md:mb-14 max-w-2xl mx-auto">
            Price depends on the complexity of the build — shape modifications, coverage area, material choices, and finish. Send us photos of your wheel and we'll quote you within 24 hours.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="https://wa.me/381642428074"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-3 bg-white text-black px-10 py-5 font-bold text-sm uppercase tracking-wider hover:bg-gray-200 transition-all cursor-pointer"
            >
              <i className="ri-whatsapp-line text-xl"></i>
              Get a Quote on WhatsApp
            </a>
            <button
              onClick={() => navigate('/order')}
              className="inline-flex items-center justify-center gap-3 border-2 border-white text-white px-10 py-5 font-bold text-sm uppercase tracking-wider hover:bg-white hover:text-black transition-all cursor-pointer"
            >
              <i className="ri-mail-send-line text-xl"></i>
              Send an Enquiry
            </button>
          </div>
        </div>
      </section>

      {/* ── LIGHTBOX ──────────────────────────────────────────────────── */}
      {lightbox && (
        <div
          className="fixed inset-0 z-[9999] bg-black/95 flex items-center justify-center"
          onClick={closeLightbox}
        >
          {/* Close */}
          <button
            onClick={closeLightbox}
            className="absolute top-4 right-4 md:top-6 md:right-6 w-12 h-12 flex items-center justify-center text-white hover:bg-white/10 transition-colors rounded-full cursor-pointer z-10"
          >
            <i className="ri-close-line text-2xl"></i>
          </button>

          {/* Prev */}
          <button
            onClick={(e) => { e.stopPropagation(); prevImage(); }}
            className="absolute left-2 md:left-6 top-1/2 -translate-y-1/2 w-12 h-12 flex items-center justify-center text-white hover:bg-white/10 transition-colors rounded-full cursor-pointer z-10"
          >
            <i className="ri-arrow-left-s-line text-3xl"></i>
          </button>

          {/* Image */}
          <img
            src={lightbox}
            alt="Steering wheel detail"
            className="max-w-[90vw] max-h-[90vh] object-contain"
            onClick={(e) => e.stopPropagation()}
          />

          {/* Next */}
          <button
            onClick={(e) => { e.stopPropagation(); nextImage(); }}
            className="absolute right-2 md:right-6 top-1/2 -translate-y-1/2 w-12 h-12 flex items-center justify-center text-white hover:bg-white/10 transition-colors rounded-full cursor-pointer z-10"
          >
            <i className="ri-arrow-right-s-line text-3xl"></i>
          </button>

          {/* Counter */}
          <div className="absolute bottom-4 left-1/2 -translate-x-1/2 text-gray-400 text-sm font-medium">
            {lightboxIdx + 1} / {allImages.length}
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
}
